/**
 * Validation functions for use with Mantine use-form
 */

import { getDateObject } from '@/lib/utils/date';
import { isEmail, matches } from '@mantine/form';

export const isDateInPast = (error?: React.ReactNode) => {
  return (date: Date) => {
    const now = new Date();
    return date < now ? null : error || true;
  };
};

export const isDateInFuture = (error?: React.ReactNode) => {
  return (date: Date | string) => {
    const dateObject = getDateObject(date);
    const now = new Date();
    return dateObject > now ? null : error || true;
  };
};

export const isDateOlderThan = (age: number, error?: React.ReactNode) => {
  return (date: Date) => {
    const now = new Date();
    const ageDate = new Date(
      now.getFullYear() - age,
      now.getMonth(),
      now.getDate()
    );
    return date < ageDate ? null : error || true;
  };
};

/**
 * Validates if a value is a US E.164 phone number: `+11234567890`
 */
export const isPhoneNumber = (error?: React.ReactNode) =>
  matches(/^\+\d{11}$/, error);

/**
 * Cascades validation through isEmail and isPhoneNumber, useful for validating user credentials.
 */
export const isEmailOrPhoneNumber =
  (error?: React.ReactNode) => (value: string) => {
    const isPhone = isPhoneNumber(error)(value);
    if (isPhone === null) {
      return null;
    }
    return isEmail(error)(value);
  };

// TODO: This function is not a validator and should be relocated.
export const isDateValid = (date: Date) =>
  date instanceof Date && !isNaN(date.valueOf());
